<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<p class="centerImage"><img alt="images" id="img7" src="images/img7.jpg"/></p>
<p class="caption">Attendees at the third annual convention of the United Indian War Veterans stand before the Yavapai County Building, Prescott, Arizona, September 14, 1931. Note the banner at right for the Gen. George Crook Camp No. 1, Los Angeles.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// IndianWarVeterans_introduction11.vue?392d56f6